import { useFlags } from 'launchdarkly-react-client-sdk';

function SideNavLayout({ menu, children }) {
  const flags = useFlags();
  const reskinFlag = flags['publishing-dashboard-reskin'];

  return (
    <div className="flex flex-wrap xl:flex-nowrap">
      <div className={reskinFlag ? 'xl:w-52 flex-none w-full bg-sentric-rebrand-mid-grey xl:gap-0 grid grid-cols-2 xl:block' : 'xl:w-80 flex-none w-full bg-old-sentric-menu-gray'}>{menu}</div>
      <div className="flex flex-grow mx-4 lg:mx-12 xl:mx-20 2xl:mx-40 my-12">
        {children}
      </div>
    </div>
  );
}

export default SideNavLayout;
